import AxiosErrorHandler from "./axiosErrorHandler";

const ErrorHandler = new AxiosErrorHandler();

export default ErrorHandler;